// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dKHX","question":"styles_question__2B1fC","inputVisibleButton":"styles_inputVisibleButton__3Zb8d","note":"styles_note__WTxCs"};